<template>
  <div class="loader-wrapper" v-if="loading">
    <div class="loader"></div>
  </div>
  <div v-else-if="!loading">
    <section class="authentication-form">
      <div class="innerpage-decor">
        <div class="innerpage-circle1">
          <img :src="'../assets/images/Testimonial2.png'" alt="" />
        </div>
        <div class="innerpage-circle2">
          <img :src="'../assets/images/Testimonial1.png'" alt="" />
        </div>
      </div>
      <div>
        <h2 class="title text-center"><span>Self Service</span></h2>
        <div class="card shadow">
          <div class="thanks-section" v-if="successful">
            <div>
              <div class="col-lg-8 offset-lg-2 pt-3">
                <h2 class="text-success text-center">{{ statusTitle }}</h2>
              </div>
              <h3 class="text-center">
                {{ statusMessage }},<br />Your Wallet Balance Is Now ₦{{
                  currentPatient.wallet_balance
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                }}
              </h3>
              <div
                id="receipt"
                style="
                  text-align: center;
                  margin: auto;
                  padding-top: 20px;
                  width: 450px;
                  border: 1px solid #ccc;
                  border-radius: 5px;
                "
              >
                <vue-html2pdf
                  :show-layout="true"
                  :float-layout="false"
                  :enable-download="true"
                  :preview-modal="false"
                  :paginate-elements-by-height="1400"
                  filename="FMCEB-SelfService-Reciept.pdf"
                  :pdf-quality="2"
                  :manual-pagination="false"
                  pdf-format="a5"
                  pdf-orientation="portrait"
                  pdf-content-width="100%"
                  @progress="onProgress($event)"
                  @hasStartedGeneration="hasStartedGeneration()"
                  @hasGenerated="hasGenerated($event)"
                  ref="receipt2PDF"
                >
                  <section slot="pdf-content">
                    <table
                      style="
                        text-align: center;
                        width: 100% !important;
                        font-family: 'Fake Receipt', Courier, monospace;
                        margin-top: 0px;
                      "
                    >
                      <tr>
                        <td style="text-align: center; margin-top: 0px">
                          <img
                            class="img-logo mx-auto"
                            src="https://revonue.nacs.com.ng/storage/img/billers/hd/2.png"
                            alt=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center">
                          <h3 style="font-size: 12px" class="my-0">
                            REVONUE SELF SERVICE KIOSK
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            FEDERAL MEDICAL CENTER EBUTTE METTA LAGOS
                          </h3>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center">
                          <h3 style="font-size: 10px" class="my-0">
                            {{
                              new Date(
                                currentPayment.payment.data.created_at
                              ).toLocaleString("en-US")
                            }}
                          </h3>
                          <h3 style="font-size: 10px" class="my-0">
                            ***REFERENCE***
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            {{ currentPayment.payment.data.tx_ref }}
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            WALLET DEPOSIT
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            #{{ currentPayment.bill.amount }}
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            TRANSACTION STATUS
                          </h3>
                          <h3
                            style="font-size: 12px; text-transform: uppercase"
                            class="my-0"
                          >
                            {{ currentPayment.payment.data.status }}
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            POWERED BY NACS (REVONUE)
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            THANK YOU
                          </h3>
                          <h3 style="font-size: 12px" class="my-0">
                            .................
                          </h3>
                          <h3
                            style="font-size: 12px; padding-bottom: 20px"
                          ></h3>
                        </td>
                      </tr>
                    </table>
                  </section>
                </vue-html2pdf>
              </div>

              <div class="mt-3 text-center">
                <h3>Do you want a receipt for this transaction?<br /></h3>

                <button
                  @click="download()"
                  class="btn btn-custom theme-color pt-2 pb-2"
                >
                  YES
                </button>
                <button
                  @click="cancel()"
                  class="btn btn-custom btn-danger pt-2 pb-2"
                >
                  NO
                </button>
              </div>
            </div>
          </div>
          <div class="thanks-section mt-5" v-if="cancelled">
            <div>
              <div class="col-lg-8 offset-lg-2 pt-3">
                <h2 class="text-danger text-center">{{ statusTitle }}</h2>
              </div>
              <h3 class="text-center">
                Transaction was cancelled,<br />Your Wallet Balance Is ₦{{
                  currentPatient.wallet_balance
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                }}
              </h3>
              <div class="mt-3 text-center">
                <button
                  @click="cancel()"
                  class="btn btn-custom btn-danger pt-2 pb-2"
                >
                  CLOSE
                </button>
              </div>
            </div>
          </div>
          <div class="thanks-section" v-if="!successful && !cancelled">
            <div>
              <div class="col-lg-8 offset-lg-2 pt-3">
                <h2 class="text-danger text-center">{{ statusTitle }}</h2>
              </div>
              <h3 class="text-center">
                {{ statusMessage }},<br />
                Your Wallet Balance Is ₦{{
                  currentPatient.wallet_balance
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                }}
              </h3>
              <div
                id="receipt"
                style="
                  text-align: center;
                  margin: auto;
                  padding-top: 20px;
                  width: 450px;
                  border: 1px solid #ccc;
                  border-radius: 5px;
                "
              >
                <table
                  style="
                    text-align: center;
                    width: 100% !important;
                    font-family: 'Fake Receipt', Courier, monospace;
                  "
                >
                  <tr>
                    <td style="text-align: center; margin-top: 0px">
                      <img
                        class="img-logo mx-auto"
                        src="https://revonue.nacs.com.ng/storage/img/billers/hd/2.png"
                        alt=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <h3 style="font-size: 12px" class="my-0">
                        REVONUE SELF SERVICE KIOSK
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">
                        FEDERAL MEDICAL CENTER EBUTTE METTA LAGOS
                      </h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">
                      <h3 style="font-size: 10px" class="my-0">
                        {{
                          new Date(
                            currentPayment.payment.data.created_at
                          ).toLocaleString("en-US")
                        }}
                      </h3>
                      <h3 style="font-size: 10px" class="my-0">
                        ***REFERENCE***
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">
                        {{ currentPayment.payment.data.tx_ref }}
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">
                        WALLET DEPOSIT
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">
                        #{{ currentPayment.bill.amount }}
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">
                        TRANSACTION STATUS
                      </h3>
                      <h3
                        style="font-size: 12px; text-transform: uppercase"
                        class="my-0"
                      >
                        {{ currentPayment.payment.data.status }}
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">
                        POWERED BY NACS (REVONUE)
                      </h3>
                      <h3 style="font-size: 12px" class="my-0">THANK YOU</h3>
                      <h3 style="font-size: 12px" class="my-0">
                        .................
                      </h3>
                      <h3 style="font-size: 12px; padding-bottom: 20px"></h3>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="mt-3 text-center">
                <button
                  @click="cancel()"
                  class="btn btn-custom btn-danger pt-2 pb-2"
                >
                  CANCEL
                </button>
              </div>

              <footer class="bg-thanks mt-5">
                <div class="container">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="copyright-section text-center">
                        <small
                          >2021 Copyright &copy; By Revonue NACS Powered By
                          Acclio</small
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters, mapState } from 'vuex'
import { CONFIRM_PAYMENT } from '@/store/payment.module'
import { GET_PATIENT, PURGE_PATIENT } from '@/store/welcome.module'
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'Completed',
  data () {
    return {
      loading: false,
      successful: false,
      statusTitle: '',
      statusMessage: '',
      timerEnabled: false,
      timerCount: 20,
      cancelled: false
    }
  },
  components: {
    VueHtml2pdf
  },
  watch: {
    timerEnabled (value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--
        }, 2000)
      }
    },

    timerCount: {
      handler (value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            this.timerCount--
          }, 2000)
        } else if (value === 0 && this.timerEnabled) {
          this.$router.push({ name: 'Welcome' })
        }
      },
      immediate: true
    }
  },

  computed: {
    ...mapState({
      errors: (state) => state.payment.errors
    }),
    ...mapGetters(['currentPatient', 'currentPayment'])
  },
  mounted () {
    this.loading = true
    let params = {
      bill_no: this.$route.query.tx_ref,
      txn_ref: this.$route.query.tx_ref,
      patient_no: this.currentPatient.id
    }
    try {
      if (this.$route.query.status === 'cancelled') {
        this.cancelled = true
        this.successful = false
        this.statusTitle = 'Payment Cancelled'
        this.statusMessage = 'Transaction failed please try again'

        this.loading = false
      } else {
        this.confirmPayment(params)
      }
    } catch (error) {
      this.$swal({
        title: 'An Error Occured',
        text: 'Unexcepted Exception Occured',
        icon: 'error',
        heightAuto: false
      })
    }
  },
  methods: {
    confirmPayment (params) {
      this.$store
        .dispatch(CONFIRM_PAYMENT, params)
        .then((response) => {
          if (this.currentPayment.payment.data.status === 'successful') {
            this.refreshPatient(this.currentPatient.id)

            this.successful = true
            this.statusTitle = 'Payment Successful'
            this.statusMessage = 'Payment was successful and wallet funded'

            this.loading = false
          } else if (this.currentPayment.payment.data.status === 'failed') {
            this.successful = false
            this.statusTitle = 'Payment Failed'
            this.statusMessage = 'Transaction failed please try again'

            this.loading = false
          } else {
            this.successful = false
            this.statusTitle = 'Payment Failed'
            this.statusMessage =
              'Unable to get transaction status at the moment please. Please take note of the transaction reference and confirm from a Revonue representative'

            this.loading = false
          }

          this.$router.push({
            query: Object.assign({}, this.$route.query, {
              mda: this.currentPayment.bill.agent.biller.short_name,
              date: this.currentPayment.payment.data.created_at,
              ref: this.$route.query.tx_ref,
              amt: this.currentPayment.bill.amount,
              status: this.currentPayment.payment.data.status
            })
          })
        })
        .catch((error) => {
          this.successful = false
          this.loading = false
          console.log(error)
          if (error.status === 400) {
            this.statusTitle = 'Payment Failed'
            this.statusMessage = error.data.message
          } else if (error.status === 404) {
            this.statusTitle = 'Payment Failed'
            this.statusMessage = error.data.message
          } else {
            this.statusTitle = 'Payment Failed'
            this.statusMessage = 'An unexpected exception has occured'
            console.log(error)
          }
        })
    },
    refreshPatient (patientNo) {
      this.$store
        .dispatch(GET_PATIENT, patientNo)
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
          this.loading = false
        })
    },
    download () {
      this.$refs.receipt2PDF.generatePdf()
      this.$router.push({ name: 'Welcome' })
      return false
    },
    print () {
      this.pause()

      var contents = document.getElementById('receipt').innerHTML
      var printFrame = document.createElement('iframe')
      printFrame.name = 'printFrame'
      printFrame.style.position = 'absolute'
      printFrame.style.top = '-1000000px'
      document.body.appendChild(printFrame)
      var frameDoc = printFrame.contentWindow
        ? printFrame.contentWindow
        : printFrame.contentDocument.document
          ? printFrame.contentDocument.document
          : printFrame.contentDocument
      frameDoc.document.open()
      frameDoc.document.write('<html><head><title>Reciept</title></head>')
      frameDoc.document.write('<body>')
      frameDoc.document.write(contents)
      frameDoc.document.write('</body></html>')
      frameDoc.document.close()
      setTimeout(function () {
        window.frames['printFrame'].focus()
        window.frames['printFrame'].print()
        document.body.removeChild(printFrame)
      }, 500)

      this.$router.push({ name: 'Welcome' })
      return false
    },
    play () {
      this.timerEnabled = true
    },
    pause () {
      this.timerEnabled = false
    },
    reset () {
      this.timerCount = 20
      this.timerEnabled = true
    },
    formatAmount (amount) {
      return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    cancel () {
      this.loading = true
      this.$store
        .dispatch(PURGE_PATIENT)
        .then((response) => {
          this.loading = false
          this.$router.push({ name: 'Welcome' })
        })
        .catch((error) => {
          this.loading = false
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/completed.vue